/** RLM-internal: detect explicit `booked_spots` / `bookedSpots` arrays on booking payloads. */

export function hasExplicitBookedSpotsArray(source: Record<string, unknown>): boolean {
  return Array.isArray(source['booked_spots']) || Array.isArray(source['bookedSpots']);
}

export function payloadHasExplicitStructuredSpots(booking: unknown): boolean {
  if (!booking || typeof booking !== 'object') {
    return false;
  }
  const record = booking as Record<string, unknown>;
  if (hasExplicitBookedSpotsArray(record)) {
    return true;
  }
  const nested = record['Booking'];
  if (nested && typeof nested === 'object') {
    return hasExplicitBookedSpotsArray(nested as Record<string, unknown>);
  }
  return false;
}
